export default __webpack_public_path__ + "static/media/hero-video-desktop-es.cf34f31f.png";